import React  from 'react';

import {toArray} from 'iss/utils/functional';
import {ValidationContext} from 'iss/widgets/form/validation/context';

/** Validates a value with the given validator.
 * Registers itself with the validator context so that a collective
 * validation result can be calculated for a form.
 *
 * props:
 * value: any value to be validated
 * validate: a validator or an array of validators. See validators.js
 */
export class Validator extends React.Component {
  static contextType = ValidationContext;
  componentDidMount() {
    this.context.addValidator(this.isValid);
  }
  componentWillUnmount() {
    this.context.removeValidator(this.isValid);
  }
  isValid = () => this.getErrors().length == 0;
  getErrors = () => {
    const {value, validate} = this.props;
    const validators = toArray(validate);
    return validators.filter(validator => !validator.rule(value))
      .map(validator => validator.getError());
  };
  getShownErrors = () => {
    return this.context.showErrors ? this.getErrors() : [];
  };
  render() {
    const {getErrors, getShownErrors, isValid} = this;
    return this.props.children({getErrors, getShownErrors, isValid});
  }
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/validation/Validator.jsx